import {
    Component, AfterViewInit, ViewChild, Input, Output, EventEmitter,
    OnChanges, SimpleChanges
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CurrencyPipe } from '@angular/common'
import { timer } from 'rxjs/observable/timer';
import { ScriptLoaderService } from './../../_services';

@Component({
    selector: 'app-select-live',
    templateUrl: './live-search-select.html'
})
export class LiveSearchSelectComponent implements AfterViewInit {
    list = [];
    firstResults = false;
    toSearch: any;
    delayTime = 700;
    delayed$: any;
    @Input() live = true;
    @Input() model; // required. Model to list, search, and create elements typed in search input
    @Input() listGetter: string = "getAll"; // function name to call
    @Input() texts = {
        notFound: "Resultados no encontrados",
        loading: "Cargando...",
        none: "Ninguno"
    }
    @Input() additionalEntries: any[];
    @Output() valueChange = new EventEmitter();
    @ViewChild('el') elDiv;
    @ViewChild('select') elSelect;
    constructor(protected _script: ScriptLoaderService, protected _sanitizer: DomSanitizer) { }
    ngOnChanges(changes: SimpleChanges) {
        if ('model' in changes) {
            let model = changes['model'].currentValue;
            if (model) {
                this.model = model;
                this.getList().subscribe(list => { });
            }
        }
    }
    ngAfterViewInit() {
        this._script.loadScripts('app-select-live',
            ['assets/demo/demo2/custom/crud/forms/widgets/bootstrap-select.js']);

        if (this.model) {
            $(this.elSelect.nativeElement).on('changed.bs.select', (e) => {
                let idx = Number(($(this.elSelect.nativeElement) as any).selectpicker('val'));
                let list =
                    (this.additionalEntries) ? (this.additionalEntries.concat(this.list)) : this.list;
                if (list.length) {
                    if (this.model.isInstance(list[idx])) {
                        this.model.instance = list[idx];
                    }
                    this.valueChange.emit(list[idx]);
                }
            });
            // reference: https://github.com/silviomoreto/bootstrap-select/issues/220
            $(this.elDiv.nativeElement).on('keyup', (e) => {
                e.preventDefault();
                e.stopPropagation();
                let search = $(e.target).val(); // TODO: change search to depend on object instance
                // instead of a string
                if (!search && !this.firstResults) {
                    this.getList().subscribe(list => { });
                    return;
                }
                let list = $(this.elDiv.nativeElement)
                    .find('ul.dropdown-menu > li');
                let count = list.filter(':not(.hidden,.no-results)').length;
                if (!count) {
                    let notFound = list.filter('.no-results');
                    this.toSearch = this.model.search(`name=${search}`);
                    if (!this.delayed$) {
                        this.runAfterDelay(() => {
                            this.search().subscribe(elements => { },
                                error => { this.delayed$ = null },
                                () => {
                                    this.delayed$ = null;
                                    notFound.html(this.texts.notFound);
                                });
                        }, this.delayTime, notFound);
                    }
                }
            });
        }
    }
    private runAfterDelay(code: Function, delayTime: number, notFound: any) { // time in milliseconds
        if (!this.delayed$) {
            notFound.html(this.texts.loading);
            this.delayed$ = timer(delayTime);
            this.delayed$.subscribe(() => { }, (error) => { }, () => {
                code();
            });
        }
    }
    private search() {
        return this.toSearch.map((elements: any[]) => {
            if (elements.length) {
                this.list = elements;
                this.refreshList();
                this.firstResults = false;
            }
            return elements;
        });
    }

    protected getOptions() {
        let options = '';
        let list = (this.additionalEntries) ? (this.additionalEntries.concat(this.list)) : this.list;
        list.forEach((el, idx) => {
            options = `${options}<option value="${idx}">${el}</option>`;
        });
        return (this._sanitizer.bypassSecurityTrustHtml(options) as any)
            .changingThisBreaksApplicationSecurity;
    }

    protected find() {
        let index = -1;
        let list = (this.additionalEntries) ? (this.additionalEntries.concat(this.list)) : this.list;
        list.forEach((el, idx) => {
            if (this.model.isInstance(el) && el.id == this.model.instance.id) {
                index = idx;
            }
        });
        return index;
    }

    private getList() {
        return this.model[this.listGetter]().map((elements: any) => {
            this.list = elements;
            this.refreshList();
            this.firstResults = true;
        });
    }

    private refreshList() {
        ($(this.elSelect.nativeElement) as any).html(this.getOptions()).selectpicker('refresh');
        ($(this.elSelect.nativeElement) as any).selectpicker('val', -1);
        if (this.model && !this.model.empty()) {
            let idx = this.find();
            if (idx != -1) ($(this.elSelect.nativeElement) as any).selectpicker('val', idx);
        }
    }

    listing(callBack?: Function) {
        this.getList().subscribe(list => {
            if (callBack) callBack(list);
        });;
    }

    clear() {
        if (this.model) this.model.make({});
        ($(this.elSelect.nativeElement) as any).selectpicker({
            noneSelectedText: this.texts.none,
            noneResultsText: this.texts.notFound
        }).selectpicker('val', -1);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/shared/live-search-select/live-search-select.component.ts